export enum SEGMENT_PERMISSIONS {
    SEGMENT_EDIT = 'SEGMENT_EDIT',
    SEGMENT_ARCHIVE = 'SEGMENT_ARCHIVE',
}
